import React, { useEffect, useState } from "react";
import AssessmentSection from "../components/AssessmentSection";
import { useParams } from "react-router-dom";
import { getAssessment, getWarmup } from "../services/AssessmentService";
import { openAssignedContent } from "../services/AssignmentService";

/**
 * One assessment on a page of its own.
 *
 * Reached two ways, and `:id` means something different in each:
 *
 * - Email invitation, `/assessment/:id/:type/:token` — the backend builds this
 *   link with the assessment's MODULE id, so it is looked up by module.
 * - From inside the app, `/assessment/:id/:type` — the learner is already
 *   signed in and `:id` is the assessment's OWN id. This is how assessments
 *   with no host PPT lesson (standalone, or attached to an Intranet article)
 *   are opened from a learning path, since they have no section workspace to
 *   deep-link into.
 */
function IndividualAssessment() {
  const { id, type, token } = useParams();
  const [module, setModule] = useState({});
  const [showAssessment, setShowAssessment] = useState(false);

  // Only the invitation link identifies content by module; without a token the
  // id is the assessment itself, so we must not resolve it by module.
  const byModule = !!token;

  useEffect(() => {
    (async () => {
      try {
        if (!id) return;
        if (token) localStorage.setItem("token", token);

        let response;
        if (type === "warmup") {
          response = await getWarmup(id);
        } else if (byModule) {
          response = await getAssessment(id);
        } else {
          // Opened from the learner's plan: fetch it on the strength of the
          // assignment, not the learner's browse scope, so an assigned
          // assessment is never unreachable.
          const payload = await openAssignedContent("assessment", id);
          response = payload?.assessment || null;
        }

        if (response) {
          setModule({
            ...response,
            title: response?.name,
            // The lesson-scoped viewer keys off `_id`; for a module-resolved
            // assessment that is the module it belongs to.
            ...(type === "assessment" && byModule ? { _id: response.module } : {}),
          });
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }, [id, type, token, byModule]);

  return (
    <div>
      {module.name && (
        <AssessmentSection
          selectedModule={module}
          type={type}
          assessmentId={byModule ? undefined : id}
          hideNavigation={'yes'}
          goBack={setShowAssessment}
        />
      )}
    </div>
  );
}

export default IndividualAssessment;
